// extracted by mini-css-extract-plugin
export default {"styleSettingsToggle":"StyleSettingsToggle_styleSettingsToggle__N10sW","toggleItemList":"StyleSettingsToggle_toggleItemList__Xz7+Z"};